/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';
import { COMMERCIAL_TOURS, FACILITIES_WITH_COMMERCIAL_VALIDATION } from '../constants';

// TODO: Temporary Indicate if commercial validation should be performed(We need to handle this in a different way)
// We do this because NARA have an special setup(tours needs to be visible for FIT and COMM users)
export const shouldMakeCommercialValidation = (facilityId) =>
    FACILITIES_WITH_COMMERCIAL_VALIDATION?.findIndex((facId) => facId === facilityId) >=
    0;

export const isCommercialTour = (tour) =>
    tour?.is_commercial_quota ||
    COMMERCIAL_TOURS?.findIndex((tourId) => tourId === tour?.tour_id) >= 0;

export const getCommTourList = (tourList) =>
    tourList.filter((tour) => isCommercialTour(tour));

export const getNonCommTourList = (tourList) =>
    tourList.filter((tour) => !isCommercialTour(tour));

export const isAccountAllowed = (isCommAccount, tourData) =>
    !isEmpty(tourData) &&
    (!shouldMakeCommercialValidation(tourData?.facility_id) ||
        (isCommAccount && isCommercialTour(tourData)) ||
        (!isCommAccount && !isCommercialTour(tourData)));
